<template>
  <div>
    <sidebar />
    <div class="relative md:ml-64 bg-blueGray-100 min-h-screen">
      <admin-navbar />
      <header-stats />

      <div class="px-4 md:px-10 mx-auto w-full dashboard-content-wrap">
        <router-view />
        <footer-admin />
      </div>
    </div>
  </div>
</template>

<script>
import AdminNavbar from "@/components/Navbars/AdminNavbar.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import HeaderStats from "@/components/Headers/HeaderStats.vue";
import FooterAdmin from "@/components/Footers/FooterAdmin.vue";

export default {
  name: "admin-layout",
  components: {
    AdminNavbar,
    Sidebar,
    HeaderStats,
    FooterAdmin,
  },
};
</script>

<style scoped>
.dashboard-content-wrap {
  position: relative;
  z-index: 10;
  margin-top: 1rem;
  padding-bottom: 2rem;
}

@media (min-width: 768px) {
  .dashboard-content-wrap {
    margin-top: 1.5rem;
  }
}
</style>
